import React from 'react';
import { EnelXGuiAtoms } from 'gui';
import PropTypes from 'prop-types';
import { isItEmpty } from 'utils';

import {
  InputWrapper, SpanError, SpanWrapper,
} from 'components/InputsStyle';

const {
  MigrationInputComment,
} = EnelXGuiAtoms;

const MainComment = ({
  errorMessage,
  ...props
}) => (
  <InputWrapper>
    <MigrationInputComment
      {...props}
    />
    {
      !isItEmpty(errorMessage)
      && !props.disabled
        ? (
          <SpanWrapper>
            <SpanError>{errorMessage}</SpanError>
          </SpanWrapper>
        )
        : null
    }
  </InputWrapper>
);

MainComment.defaultProps = {
  borderColor: '',
  disabled: false,
  errorMessage: '',
  label: '',
  onBlur: () => {},
  onChange: () => {},
  onFocus: () => {},
  onKeyDown: () => {},
  placeholder: '',
  round: false,
  value: '',
};

MainComment.propTypes = {
  borderColor: PropTypes.string,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string,
  label: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  placeholder: PropTypes.string,
  round: PropTypes.bool,
  value: PropTypes.string,
};

MainComment.displayName = 'MainComment';

export default MainComment;
